export default __webpack_public_path__ + "static/media/LogisticsServices.25e5d08a.png";